// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","logo":"Header_logo__W53xq","textcolor":"Header_textcolor__4TJJ9"};